export { default } from './AlfaLeasingQuiz';
